export default {
  getTableSettings: (state) => state.tableSettings,
  getApplications: (state) => state.applications,
  getIsTableLoading: (state) => state.isTableLoading,
  getApplicationssFLead: (state) => state.applications,
}
